import React from "react";
import Cropper from "react-easy-crop";
import { previewUrl } from "../lib/api";

// Controlled wrapper around react-easy-crop.
// croppedAreaPixels is reported in the PREVIEW image's natural pixels;
// the backend reproduces the exact same crop on the full-res original.
export const CropEditor = ({ photo, onChange }) => {
  const imageUrl = previewUrl(photo.photo_id);
  return (
    <div className="crop-frame border shadow-[var(--shadow-card)]">
      <Cropper
        image={imageUrl}
        crop={photo.cropPos || { x: 0, y: 0 }}
        zoom={photo.zoom || 1}
        rotation={photo.rotation || 0}
        aspect={1}
        minZoom={1}
        maxZoom={3}
        restrictPosition={true}
        showGrid={true}
        onCropChange={(cropPos) => onChange({ cropPos, approved: false })}
        onZoomChange={(zoom) => onChange({ zoom, approved: false })}
        onRotationChange={(rotation) => onChange({ rotation, approved: false })}
        onCropComplete={(_area, areaPixels) => onChange({ crop: areaPixels })}
      />
    </div>
  );
};
